/* var options = {
    now: "0:00",
    twentyFour: true,
} */



if ($('.timepicker').length) {
    $('.timepicker').wickedpicker({
        now: "0:00",
        twentyFour: true,
    });

    let closeTimePicker = $('.wickedpicker__close');
    let dobTime = $('.dob-time-user');
    let btnAll = $('.js-add-time-all');
    let tableAddedTime = $('.added-time');
    let startValAll = btnAll[0].value;
    let startValDob = startValAll;


    dobTime.on('click', function () {
        $(this).addClass('active');

        closeTimePicker.on('click', function () {
            let activeTimeBtn = $('.dob-time-user.active');
            let activeTimeBtnVal = activeTimeBtn.val();

            if (dobTime.hasClass('active')) {

                if (startValDob != activeTimeBtnVal) {
                    let thisAddTimeParent = activeTimeBtn.parents('tr');
                    let thisAddTime = thisAddTimeParent.find('.added-time')[0];

                    thisAddTime.innerHTML = activeTimeBtnVal;
                    activeTimeBtn.removeClass('active');
                }
            }
        })
    });




    btnAll.on('click', function () {
        $(this).addClass('all-btn');

        closeTimePicker.on('click', function () {

            if (btnAll.hasClass('all-btn')) {
                let cureentVal = btnAll[0].value;

                if (startValAll != cureentVal) {

                    for (let i = 0; i < tableAddedTime.length; i++) {
                        tableAddedTime[i].innerHTML = cureentVal;
                    }

                    btnAll.removeClass('all-btn');
                };
            }
        })
    });

}